
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.2742 4.28199C24.2572 1.52068 20.2534 0 16.0004 0C11.7474 0 7.74358 1.52068 4.72665 4.28199C1.6789 7.07142 0.000407887 10.789 0.000407887 14.75C0.000407887 17.839 1.01053 20.7658 2.92978 23.2607L0.0915327 30.2814C-0.0991544 30.7531 0.0150329 31.2933 0.380345 31.6474C0.618469 31.8782 0.932094 31.9999 1.25072 31.9999C1.42091 31.9999 1.59253 31.9652 1.75465 31.8938L9.79564 28.3491C11.7607 29.113 13.8454 29.4999 16.0004 29.4999C18.6977 29.4999 21.3646 28.8696 23.7128 27.6769C24.3283 27.3643 24.5739 26.6119 24.2612 25.9964C23.9486 25.3809 23.1962 25.1354 22.5807 25.448C20.5816 26.4633 18.3062 26.9999 16.0004 26.9999C13.9971 26.9999 12.068 26.6103 10.2668 25.8419C9.9487 25.7061 9.58858 25.7083 9.27208 25.8478L3.56303 28.3644L5.5234 23.5151C5.69796 23.0833 5.61802 22.5902 5.31583 22.2358C3.47396 20.075 2.5004 17.4864 2.5004 14.75C2.5004 7.9953 8.55645 2.5 16.0004 2.5C23.4443 2.5 29.5004 7.9953 29.5004 14.75C29.5004 17.076 28.7786 19.3391 27.413 21.2946C27.0177 21.8606 27.1561 22.6398 27.7222 23.0351C28.288 23.4304 29.0675 23.2919 29.4627 22.7259C31.1228 20.3486 32.0003 17.5905 32.0003 14.75C32.0003 10.789 30.3219 7.07142 27.2742 4.28199Z"}})])
          )
        }
      }
    